/**
 * @param {import("./temarioTree").TemarioNodo | null | undefined} node
 * @returns {boolean}
 */
export function temarioNodeHasVisibleContent(node) {
  if (!node || typeof node !== "object") {
    return false;
  }
  if (Array.isArray(node.archivos) && node.archivos.length > 0) {
    return true;
  }
  if (Array.isArray(node.testRefs) && node.testRefs.length > 0) {
    return true;
  }
  if (!Array.isArray(node.hijos)) {
    return false;
  }
  return node.hijos.some((child) => temarioNodeHasVisibleContent(child));
}

/**
 * @param {import("./temarioTree").TemarioNodo | null | undefined} node
 * @returns {boolean}
 */
export function temarioNodeHasDocumentFiles(node) {
  if (!node || typeof node !== "object") {
    return false;
  }
  if (Array.isArray(node.archivos) && node.archivos.length > 0) {
    return true;
  }
  if (!Array.isArray(node.hijos)) {
    return false;
  }
  return node.hijos.some((child) => temarioNodeHasDocumentFiles(child));
}

/**
 * @param {import("./temarioTree").TemarioNodo[] | null | undefined} nodes
 * @returns {import("./temarioTree").TemarioNodo[]}
 */
/**
 * Titles already placed on this node via testRefs (admin mixed list).
 * @param {import("./temarioTree").TemarioNodo | null | undefined} node
 * @returns {Set<string>}
 */
export function listLinkedTestTitles(node) {
  const titles = new Set();
  const refs = Array.isArray(node?.testRefs) ? node.testRefs : [];
  refs.forEach((ref) => {
    const title = typeof ref?.titulo === "string" ? ref.titulo.trim() : "";
    if (title) {
      titles.add(title);
    }
  });
  return titles;
}

/**
 * True when a child is only a test already listed on the parent mixed list.
 * Those children must not appear again after the files in the student campus.
 * @param {import("./temarioTree").TemarioNodo | null | undefined} child
 * @param {Set<string>} parentTestTitles
 * @returns {boolean}
 */
export function temarioChildDuplicatesLinkedTests(child, parentTestTitles) {
  if (!child || typeof child !== "object" || !(parentTestTitles instanceof Set) || parentTestTitles.size === 0) {
    return false;
  }
  if (Array.isArray(child.archivos) && child.archivos.length > 0) {
    return false;
  }
  if (Array.isArray(child.hijos) && child.hijos.some((nested) => temarioNodeHasVisibleContent(nested))) {
    return false;
  }
  const refs = Array.isArray(child.testRefs) ? child.testRefs : [];
  const childName = typeof child.nombre === "string" ? child.nombre.trim() : "";
  if (refs.length > 0) {
    return refs.every((ref) => {
      const title = typeof ref?.titulo === "string" ? ref.titulo.trim() : "";
      return title.length > 0 && parentTestTitles.has(title);
    });
  }
  return childName.length > 0 && parentTestTitles.has(childName);
}

export function filterVisibleTemarioNodes(nodes) {
  if (!Array.isArray(nodes)) {
    return [];
  }
  return nodes.filter((node) => temarioNodeHasVisibleContent(node));
}
